import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getDisplayShippingInfo } from "@qgiv/p2p-registration";
import { selectAllRegistration } from "../../redux/slices/registrationSlice";
import { selectOfferShipping } from "../../redux/slices/productSettingsSlice";
import { selectAllProducts } from "../../redux/slices/productsSlice";
import ShippingInfoControl from "./ShippingInfoControl";

const ConnectedShippingInfoControl = ({ controlId }) => {
    const registration = useSelector(selectAllRegistration);
    const { storeCart = [] } = registration;

    const offerShipping = useSelector(selectOfferShipping);
    const products = useSelector(selectAllProducts);

    const isVisible = getDisplayShippingInfo(
        products,
        storeCart,
        offerShipping,
    );
    return <ShippingInfoControl controlId={controlId} isVisible={isVisible} />;
};

ConnectedShippingInfoControl.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedShippingInfoControl;
